export default function() {}



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-shape/src/noop.js
// module id = ../../../../d3-shape/src/noop.js
// module chunks = 4